// src/config/ag-grid-initializer.js
import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';

// Registramos todos los módulos de Community (incluyendo ClientSideRowModelModule)
ModuleRegistry.registerModules([AllCommunityModule]);

// Configuramos el tema a legacy para mantener compatibilidad con versiones anteriores
provideGlobalGridOptions({ theme: "legacy" });

//console.log("AG Grid inicializado correctamente con módulos Community");